// Import all pages
import AccountLogin from '@/pages/AccountLogin'
import AccountRegister from '@/pages/AccountRegister'
import AccountConfirm from '@/pages/AccountConfirm'
import AccountLoginGlHomes from '@/pages/AccountLoginGlHomes.vue'
import AccountResetPassword from '@/pages/AccountResetPassword'
import AccountConfirmResetPassword from '@/pages/AccountConfirmResetPassword'
// import Account from '@/pages/Account'
import AccountLayout from '@/pages/AccountLayout'
import AccountProfile from '@/pages/AccountProfile'
import AccountSecurity from '@/pages/AccountSecurity'
import AccountIntegration from '@/pages/AccountIntegration'
import DashboardStart from '@/pages/DashboardStart'
import Home from '@/pages/Home'
import DashboardProject from '@/pages/DashboardProject'
import AdminRegisteredUsers from '@/pages/AdminRegisteredUsers'
import Workflow from '@/pages/Workflow'
import NotFound from '@/pages/NotFound'
import Plans from '@/pages/Plans.vue'
import Checkout from '@/pages/Checkout.vue'
import Payment from '@/pages/Payment.vue'
import Subscription from '@/pages/Subscription.vue'
import MyPlan from '@/pages/MyPlan.vue'
import Billing from '@/pages/Billing.vue'
import ManageUsers from '@/pages/ManageUsers.vue'
import ManageBilling from '@/pages/ManageBilling.vue'
import BillingLayout from '@/pages/BillingLayout.vue'
import AdminLayout from '@/pages/AdminLayout.vue'
import AdminSubscriptions from '@/components/AdminSubscriptions.vue'
import AdminEnterpriseCustomers from '@/components/AdminEnterpriseCustomers.vue'
import OAuthLogin from '@/pages/OAuthLogin.vue'
import AdminSettings from '@/pages/AdminSettings.vue'
import BillingHistory from '@/pages/BillingHistory.vue'
import GitHubCallback from '@/pages/GitHubCallback.vue'
import OrgAdminPage from '@/pages/OrgAdminPage'
import OrgDashboard from '@/pages/OrgDashboard'
import { latchEmbedMode, EMBED_QUERY_PARAM, EMBED_QUERY_VALUE } from '@/utils/embed'

const routes = [
  { path: '/login', component: AccountLogin, meta: { requiresNoAuth: true } },
  { path: '/login-with-provider/glhomes', component: AccountLoginGlHomes, meta: { requiresNoAuth: true } },
  { path: '/signup', component: AccountRegister, meta: { requiresNoAuth: true } },
  { path: '/confirm', component: AccountConfirm, meta: { requiresNoAuth: true } },
  { path: '/reset-password', component: AccountResetPassword, meta: { requiresNoAuth: true } },
  { path: '/confirm-reset-password', component: AccountConfirmResetPassword, meta: { requiresNoAuth: true } },
  { path: '/oauth-login', component: OAuthLogin, meta: { requiresNoAuth: true } },
  // { path: '/account', component: Account, meta: { requiresAuth: true } },
  {
    path: '/account',
    component: AccountLayout,
    meta: { requiresAuth: true },
    children: [
      { path: 'profile', component: AccountProfile },
      { path: 'security', component: AccountSecurity },
      { path: 'integration', component: AccountIntegration }
    ]
  },
  { path: '/dashboard/:projectId', component: DashboardProject, meta: { requiresAuth: true, requiresProject: true } },
  { path: '/dashboard', component: Home, meta: { requiresAuth: true } },
  { path: '/workspaces', component: DashboardStart, meta: { requiresAuth: true } },
  { path: '/', redirect: '/dashboard', requiresProject: true },
  { path: '/plans', component: Plans, meta: { requiresAuth: true } },
  { path: '/checkout', component: Checkout, meta: { requiresAuth: true } },
  { path: '/payment', component: Payment, meta: { requiresAuth: true } },
  {
    path: '/subscription',
    component: Subscription,
    meta: { requiresAuth: true },
    children: [
      { path: 'my-plan', component: MyPlan },
      {
        path: 'billing',
        component: BillingLayout,
        children: [
          { path: '', component: Billing },
          { path: 'manage-billing', component: ManageBilling },
          { path: 'billing-history', component: BillingHistory }
        ]
      },
      { path: 'manage-users', component: ManageUsers }
    ]
  },
  {
    // Public embed entry point. CloudFront gives /embed/* permissive framing; the SPA
    // latches embed mode and redirects into the workflow route (keyed on ?embed=1).
    path: '/embed/:projectId/:id',
    redirect: (to) => {
      latchEmbedMode()

      return {
        path: `/workflow/${to.params.projectId}/${to.params.id}`,
        query: { [EMBED_QUERY_PARAM]: EMBED_QUERY_VALUE }
      }
    }
  },
  { path: '/workflow/:projectId/:id/version/:version', component: Workflow, meta: { allowNonTeamMember: true, requiresProject: true } },
  { path: '/workflow/:projectId/:id', component: Workflow, meta: { allowNonTeamMember: true, requiresProject: true } },
  { path: '/workflow/:projectId/:id/:eventId', component: Workflow, meta: { allowNonTeamMember: true, requiresProject: true } },
  { path: '/org/:orgId', component: OrgDashboard, meta: { requiresAuth: true } },
  { path: '/org/:orgId/admin', component: OrgAdminPage, meta: { requiresAuth: true, requiresOrgOwner: true } },
  { path: '/github/callback', component: GitHubCallback },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', component: AdminRegisteredUsers },
      { path: 'subscriptions', component: AdminSubscriptions },
      { path: 'enterprise-customers', component: AdminEnterpriseCustomers },
      { path: 'settings', component: AdminSettings }
    ]
  },
  { path: '/404', component: NotFound },
  { path: '/:pathMatch(.*)*', redirect: '/404' }
]

export default routes
